/** Story points / estimate are static columns — not duplicated as dynamic custom-field columns. */
const isEstimateOrStoryPointCustomField = (fieldName, isGithubIssuesBoard) => {
  const normalized = String(fieldName || '')
    .trim()
    .toLowerCase();
  if (!normalized) {
    return false;
  }
  if (isGithubIssuesBoard) {
    return normalized === 'estimate';
  }
  return (
    normalized === 'estimate' ||
    normalized === 'story points' ||
    normalized.includes('story point')
  );
};

const excludedFields = new Set([
  'development',
  'rank',
  '[chart] date of first response',
  '[CHART] Date of First Response',
  '[CHART] Time in Status',
  '[chart] time in status',
]);

export const shouldIncludeCustomField = (fieldName, staticColumnNames, isGithubIssuesBoard) => {
  const displayName = fieldName.toUpperCase().replace(/_/g, ' ');
  const normalizedFieldName = fieldName.toLowerCase();

  const isStaticColumn = staticColumnNames.has(displayName);
  const isExcludedField =
    excludedFields.has(normalizedFieldName) ||
    excludedFields.has(fieldName.toLowerCase()) ||
    excludedFields.has(fieldName);
  const isEstimateOrStoryPointField = isEstimateOrStoryPointCustomField(
    fieldName,
    isGithubIssuesBoard,
  );

  const isCustomField = normalizedFieldName.startsWith('customfield');

  const isDeveloperField =
    staticColumnNames.has('DEVELOPER') &&
    (displayName.includes('DEVELOPER') ||
      displayName.includes('DEVELOPED BY') ||
      normalizedFieldName.includes('developer') ||
      normalizedFieldName.includes('developed_by'));

  const shouldInclude =
    !isStaticColumn &&
    !isExcludedField &&
    !isEstimateOrStoryPointField &&
    !isCustomField &&
    !isDeveloperField;

  return shouldInclude;
};
